<template>
  <v-dialog  width="900px" :value="show" @input="$emit('change-value', $event)">
    <v-card height="550px">
      <v-card-text class="h-100">
        <v-layout column class="h-100">
          <v-flex>
            <vue-perfect-scrollbar>
              <v-list class="scrollBar">
                <v-layout row wrap>
                  <v-flex xs12 md6>
                    <v-subheader class="f1-5em">Gestionando</v-subheader>
                    <template v-if="manageds.length > 0">
                      <vue-perfect-scrollbar class="customer-status--scrollbar">
                        <v-list-tile class="b-borders ml-4" v-for="(manageds, i) in manageds" :key="i">
                          <v-layout row wrap class="f0-9em">
                            <v-flex md6>
                              <v-icon small class="pr-3">fas fa-{{ showIconChannel(manageds.channel_id) }}</v-icon>
                              {{ showNameChannel(manageds.channel_id) }}
                            </v-flex>
                            <v-flex md6 class="pl-4">
                              {{new Intl.NumberFormat('es-VE').format(manageds.quantity)}}
                            </v-flex>
                          </v-layout>
                        </v-list-tile>
                        <v-list-tile class="ml-4">
                          <v-layout row wrap class="f0-9em">
                            <v-flex md6>
                              <strong>Total</strong>
                            </v-flex>
                            <v-flex md6 class="pl-4">
                              {{new Intl.NumberFormat('es-VE').format(managedTotal)}}
                            </v-flex>
                          </v-layout>
                        </v-list-tile>
                      </vue-perfect-scrollbar>
                    </template>
                    <template v-else>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex md12 class="text-xs-center">
                            No se encontraron resultados
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                    </template>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-subheader class="f1-5em">No gestionando</v-subheader>
                    <template v-if="unmanageds.length > 0">
                      <vue-perfect-scrollbar class="customer-status--scrollbar">
                        <v-list-tile class="b-borders ml-4" v-for="(unmanaged, i) in unmanageds" :key="i">
                          <v-layout row wrap class="f0-9em">
                            <v-flex md6>
                              <v-icon small class="pr-3">fas fa-{{ getCustomerField('id', unmanaged.customer_status_id, 'icon') }}</v-icon>
                              {{ getCustomerField('id', unmanaged.customer_status_id, 'status') }}
                            </v-flex>
                            <v-flex md6 class="pl-4">
                              {{new Intl.NumberFormat('es-VE').format(unmanaged.quantity)}}
                            </v-flex>
                          </v-layout>
                        </v-list-tile>
                        <v-list-tile class="ml-4">
                          <v-layout row wrap class="f0-9em">
                            <v-flex md6>
                              <strong>Total</strong>
                            </v-flex>
                            <v-flex md6 class="pl-4">
                              {{new Intl.NumberFormat('es-VE').format(unmanagedTotal)}}
                            </v-flex>
                          </v-layout>
                        </v-list-tile>
                      </vue-perfect-scrollbar>
                    </template>
                    <template v-else>
                      <v-list-tile>
                        <v-layout row wrap>
                          <v-flex md12 class="text-xs-center">
                            No se encontraron resultados
                          </v-flex>
                        </v-layout>
                      </v-list-tile>
                    </template>
                  </v-flex>
                </v-layout>
              </v-list>
            </vue-perfect-scrollbar>
          </v-flex>
          <v-flex>
            <v-layout class="h-100" justify-end align-end>
              <v-btn flat  @click="$emit('change-value', false)">Cerrar</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import reportsListMixin from '@/mixins/reportsList';
import formatDateMixin from '@/mixins/formatDate';
import channelMixin from '@/mixins/channels';
import statusMixin from '@/mixins/status';

export default {
  mixins: [
    statusMixin,
    channelMixin,
    formatDateMixin,
    reportsListMixin,
  ],
  components: {
    VuePerfectScrollbar,
  },
  props: {
    filters: {
      type: Object,
      default: () => {},
    },
    show: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      manageds: [],
      unmanageds: [],
      report: [],
      cancelToken: this.axios.CancelToken.source(),
      collections: [
        {
          descrip: 'Por cobrar',
          quantity: 0,
          amount: 0,
          position: 1,
        },
        {
          descrip: 'Cobrado',
          quantity: 0,
          amount: 0,
          position: 1,
        },
        {
          descrip: 'Total',
          quantity: 0,
          amount: 0,
          position: 1,
        },
      ],
    };
  },
  computed: {
    /* eslint-disable */
    managedTotal() {
      let total = 0;
      if (this.manageds.length > 0) {
        this.manageds.forEach((managed) => {
          total += parseInt(managed.quantity);
        });
      }
      return total;
    },
    managedTotalAmount() {
      let total = 0;
      if (this.manageds.length > 0) {
        this.manageds.forEach((managed) => {
          total += parseInt(managed.amount);
        });
      }
      return total;
    },
    unmanagedTotal() {
      let total = 0;
      if (this.unmanageds.length > 0) {
        this.unmanageds.forEach((unmanaged) => {
          total += parseInt(unmanaged.quantity);
        });
      }
      return total;
    },
    unmanagedTotalAmount() {
      let total = 0;
      if (this.unmanageds.length > 0) {
        this.unmanageds.forEach((unmanaged) => {
          total += parseInt(unmanaged.amount);
        });
      }
      return total;
    },
    collectionTotal() {
      return this.collections.filter(collection => collection.descrip === 'Total');
    },
    /* eslint-enable */
  },
  methods: {
    cancelRequest() {
      this.cancelToken.cancel('');
      this.cancelToken = this.axios.CancelToken.source();
    },
    getReport() {
      this.manageds = [];
      this.unmanageds = [];
      this.cancelRequest();
      this.axios.get('/reports', {
        cancelToken: this.cancelToken.token,
        params: {
          ...this.filters,
        },
      }).then((response) => {
        if (response.data) {
          this.manageds = response.data.managed;
          this.unmanageds = response.data.unmanaged;
        } else {
          this.manageds = [];
          this.unmanageds = [];
        }
      });
    },
  },
  watch: {
    show: {
      immediate: true,
      handler(value) {
        if (value) {
          this.getReport();
        } else {
          this.cancelRequest();
        }
      },
    },
  },
};
</script>
<style scoped>
.scrollBar {
  height: 450px;
}
</style>



// WEBPACK FOOTER //
// src/components/panelV2/ScheduleDaily/DailyLoad/Status.vue